/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ErrorHeader: {
        id: 'sph.error.ErrorHeader',
        defaultMessage: 'Thank you for your interest in Saga Home Insurance.'
    },
    SagaHomepage: {
        id: 'sph.error.SagaHomepage',
        defaultMessage: 'Return to homepage'
    },
    NewQuote: {
        id: 'sph.error.NewQuote',
        defaultMessage: 'Begin a new quote'
    },
    HomeErrorText1: {
        id: 'sph.error.HomeErrorText1',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to complete your online quotation.'
    },
    HomeErrorText2: {
        id: 'sph.error.HomeErrorText2',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to offer you a quotation.'
    },
    HomeErrorAge: {
        id: 'sph.error.HomeErrorAge',
        defaultMessage: 'We are sorry that, based on the date of birth you entered, we are unable to offer you a quote. Saga is only able to quote for customers aged 50 and over. '
    },
    HomeErrorThreeProperties: {
        id: 'sph.error.HomeErrorThreeProperties',
        defaultMessage: 'Sorry - we are unable to provide a quote for properties where you already insure 3 or more properties with Saga. For more information, please call us on {phoneNumber} and one of our customer service advisers will be pleased to help.'
    },
    HomeErrorFlood: {
        id: 'sph.error.HomeErrorFlood',
        defaultMessage: 'Unfortunately, we are unable to provide you with a quotation online.'
    },
    HomeErrorReferralGeneral1: {
        id: 'sph.error.HomeErrorReferralGeneral1',
        defaultMessage: 'Unfortunately, we are unable to provide you with a quotation online. Please contact us via '
    },
    WebChat: {
        id: 'sph.error.WebChat',
        defaultMessage: 'web chat'
    },
    HomeErrorReferralGeneral2: {
        id: 'sph.error.HomeErrorReferralGeneral2',
        defaultMessage: ' where one of our Customer Service Advisers will be happy to help.'
    },
    HomeErrorReferralBusinessType1: {
        id: 'sph.error.HomeErrorReferralBusinessType1',
        defaultMessage: 'Unfortunately, we are unable to provide a quote online for the business type you have selected.'
    },
    HomeErrorReferralBusinessType2: {
        id: 'sph.error.HomeErrorReferralBusinessType2',
        defaultMessage: 'We may be able to provide cover if the number of guests, catered for by your property, is no more than six at any one time. If this is the case please call {phoneNumber} to speak to one of our insurance advisers.'
    },
    HomeErrorReferralPleaseCall: {
        id: 'sph.error.HomeErrorReferralPleaseCall',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to complete your online quotation. Please call {phoneNumber} and one of our Customer Service Advisers will be happy to help.'
    },
    HomeErrorReferralFlooding: {
        id: 'sph.error.HomeErrorReferralFlooding',
        defaultMessage: 'Unfortunately, we are unable to provide you with a quotation online. Please call us on {phoneNumber} where one of our advisers will be happy to help.'
    },
    HomeErrorTenancyAgreement: {
        id: 'sph.error.HomeErrorTenancyAgreement',
        defaultMessage: 'Unfortunately, we are unable to provide you with a quotation online. Please call us on {phoneNumber} where one of our Customer Service Advisers will be able to help.'
    },
    HomeErrorErrorMessageAbilityToPay: {
        id: 'sph.error.HomeErrorErrorMessageAbilityToPay',
        defaultMessage: 'Please call us on {phoneNumber}, 8:30am to 8pm weekdays and 9am to 5pm Saturday and Sunday so we can discuss your options with you. The details of your quotation have been saved.'
    }
});
